<template>
  <v-container fluid>
    <v-row>
      <v-col :cols="6" sm="12" md="12" lg="5" xl="6">
        <v-card>
          <v-data-table
            :loading="loading"
            :headers="headers"
            :items="entities"
            :items-per-page="4"
            sort-by="name"
            class="elevation-1"
            loading-text="Chargement en cours"
            :footer-props="{ 'items-per-page-options': [4] }"
          >
            <template v-slot:top>
              <v-toolbar flat color="white" :extended="$vuetify.breakpoint.xs">
                <v-toolbar-title class="mr-2">{{
                  $store.state.auth.user ? $store.state.auth.user.name : ""
                }}</v-toolbar-title>
                <v-divider vertical class="mr-2"></v-divider>
                <v-toolbar-title>{{ $t("Entities") }}</v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
      <v-col :cols="6" sm="12" md="12" lg="7" xl="6">
        <v-card>
          <v-data-iterator
            :loading="loading"
            :items="licenceExpiration"
            sort-by="name"
            class="elevation-1"
            :items-per-page="2"
            :footer-props="{ 'items-per-page-options': [2] }"
          >
            <template v-slot:header>
              <v-toolbar
                flat
                color="white"
                class="mb-1"
                :extended="$vuetify.breakpoint.xs"
              >
                <v-toolbar-title>{{
                  $t("Licences expiring soon")
                }}</v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
            </template>

            <template v-slot:default="props">
              <v-row>
                <v-col
                  v-for="item in props.items"
                  :key="item.id"
                  cols="12"
                  sm="6"
                  md="6"
                  lg="6"
                >
                  <v-card class="mx-2">
                    <v-card-title class="subheading font-weight-bold">
                      {{ item.application.name }}
                      <v-spacer></v-spacer>
                      <v-icon color="primary" @click="renewLicence(item)"
                        >mdi-autorenew</v-icon
                      >
                    </v-card-title>

                    <v-divider></v-divider>
                    <v-card-actions>
                      <v-list dense style="width: 100%">
                        <v-list-item>
                          <v-list-item-content
                            >{{ $t("Device") }}:</v-list-item-content
                          >
                          <v-list-item-content class="align-end">{{
                            item.serial_number == null
                              ? $t("None")
                              : item.serial_number
                          }}</v-list-item-content>
                        </v-list-item>

                        <v-list-item>
                          <v-list-item-content
                            >{{ $t("Customer") }}:</v-list-item-content
                          >
                          <v-list-item-content class="align-end">{{
                            item.client == null ? $t("None") : item.client.name
                          }}</v-list-item-content>
                        </v-list-item>

                        <v-expansion-panels accordion flat>
                          <v-expansion-panel>
                            <v-expansion-panel-header></v-expansion-panel-header>
                            <v-expansion-panel-content
                              >{{ $t("Entity") }} :
                              {{
                                item.reseller_entity.name
                              }}</v-expansion-panel-content
                            >
                            <v-expansion-panel-content
                              >{{ $t("Expiration date") }} :
                              {{
                                item.expire == null
                                  ? $t("None")
                                  : $d(Date.parse(item.expire))
                              }}</v-expansion-panel-content
                            >
                          </v-expansion-panel>
                        </v-expansion-panels>
                      </v-list>
                    </v-card-actions>
                  </v-card>
                </v-col>
              </v-row>
            </template>
          </v-data-iterator>
        </v-card>
      </v-col>
    </v-row>
    <add-edit-licence-dialog
      v-model="dialog"
      @close="close"
    ></add-edit-licence-dialog>
    <attach-licence-dialog
      v-model="attachLicenceDialog"
    ></attach-licence-dialog>
    <renew-licence-dialog v-model="renewLicenceDialog"></renew-licence-dialog>
  </v-container>
</template>

<script>
import { saveAs } from "file-saver";
import snackbar from "@/mixins/snackbar";
import { mapState } from "vuex";
import AddEditLicenceDialog from "@/components/AddEditLicenceDialog";
import AttachLicenceDialog from "@/components/AttachLicenceDialog";
import RenewLicenceDialog from "@/components/RenewLicenceDialog";

export default {
  name: "Accueil",
  components: { AddEditLicenceDialog, AttachLicenceDialog, RenewLicenceDialog },
  mixins: [snackbar],
  data() {
    return {
      loading: false,
      dialog: false,
      attachLicenceDialog: false,
      renewLicenceDialog: false,
      widthModal: window.innerWidth * 0.9,
    };
  },
  computed: {
    ...mapState({
      licences: (state) => state.licences.items,
      entities: (state) => state.auth.user?.reseller_entities ?? [],
    }),
    licenceExpiration() {
      let licenceOnlyCloseExpiration = [];
      this.licences.forEach((lic) => {
        if (lic.is_expired && lic.plan !== 0 && lic.expire) {
          licenceOnlyCloseExpiration.push(lic);
        }
      });
      return licenceOnlyCloseExpiration;
    },
    headers() {
      return [
        {
          text: this.$t("Entity"),
          align: "start",
          sortable: true,
          value: "name",
        },
        {
          text: "ID",
          align: "start",
          sortable: true,
          value: "entity_app_id",
        },
      ];
    },
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
  },
  created() {
    if (this.licences.length === 0) {
      this.loading = true;
      this.$store
        .dispatch("licences/fetchAll")
        .then(() => (this.loading = false))
        .catch(() => (this.loading = false));
    }
  },
  methods: {
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.$store.dispatch("licences/resetEditedItem");
      }, 300);
    },
    editItem(item) {
      this.$store.commit("licences/setEditedId", item.id);
      this.$store.commit(
        "licences/setEditedItem",
        Object.assign({ quantity: 1 }, item)
      );
      this.dialog = true;
    },
    attachLicence(item) {
      this.$store.commit("licences/setSelectedItem", item);
      this.attachLicenceDialog = true;
    },
    renewLicence(item) {
      this.$store.commit("licences/setSelectedItem", item);
      this.renewLicenceDialog = true;
    },
    viewLicenceFile(item) {
      const xml = item.xml;
      var blob = new Blob([xml], { type: "text/plain;charset=utf-8" });
      saveAs(blob, "" + item.serial_number + ".lic");
    },
  },
};
</script>